<script setup lang="ts">
import { useToast } from '~/composables/useToast';
const { toasts, dismiss } = useToast();
</script>

<template>
  <Teleport to="body">
    <div class="fixed z-[100] bottom-10 inset-x-0 flex justify-center pointer-events-none">
      <div class="flex flex-col gap-2 w-[min(92vw,520px)] px-3">
        <div
          v-for="t in toasts"
          :key="t.id"
          class="pointer-events-auto rounded-lg border-2 px-3 py-2 shadow bg-white"
          :class="{
            'border-green-500/40': t.kind === 'success',
            'border-red-500/40': t.kind === 'error',
            'border-gray-400/40': t.kind === 'info',
          }"
          role="status"
          aria-live="polite"
        >
          <div class="flex items-center gap-2">
            <font-awesome
              :icon="
                t.kind === 'success'
                  ? ['fas', 'circle-check']
                  : t.kind === 'error'
                    ? ['fas', 'circle-xmark']
                    : ['fas', 'circle-info']
              "
            />
            <span class="text-sm">{{ t.text }}</span>
            <button class="ml-auto text-xs opacity-70 hover:opacity-100" @click="dismiss(t.id)">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
